import { render, staticRenderFns } from "./ListagemFuncionarioSindicatos.vue?vue&type=template&id=6a85a04a&scoped=true"
import script from "./ListagemFuncionarioSindicatos.vue?vue&type=script&lang=js"
export * from "./ListagemFuncionarioSindicatos.vue?vue&type=script&lang=js"
import style0 from "./ListagemFuncionarioSindicatos.vue?vue&type=style&index=0&id=6a85a04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85a04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
